import React, { FC, useRef } from 'react';
import { Box, Dialog, IconButton, useMediaQuery, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

type Props = {
    open: boolean;
    onClose: () => void;
};

// DD-3609: the Lab Rush arcade game. It is a standalone page in public/lab-rush (vanilla JS + canvas),
// shown in an iframe so it keeps its own keyboard handling. The game takes the two-letter language
// from ?lang= (sv_SE -> sv) and ?embedded=1 leaves room for the close button in its brand bar.
const LabRushDialog: FC<Props> = ({ open, onClose }) => {
    const { t: translate, i18n } = useTranslation(['navigation', 'common']);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const iframeRef = useRef<HTMLIFrameElement>(null);

    const src = `/lab-rush/index.html?embedded=1&lang=${encodeURIComponent(i18n.language)}`;

    // The game listens for keys 1–5 on its own window, so give it focus as soon as it has loaded
    const handleLoad = () => iframeRef.current?.contentWindow?.focus();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={fullScreen}
            maxWidth="lg"
            fullWidth
            PaperProps={{ sx: { height: fullScreen ? '100%' : '90vh', overflow: 'hidden' } }}
        >
            <IconButton
                onClick={onClose}
                aria-label={translate('common:CLOSE')}
                sx={{ position: 'absolute', top: 10, right: 12, color: '#fff', zIndex: 1 }}
            >
                <CloseIcon />
            </IconButton>
            <Box
                component="iframe"
                ref={iframeRef}
                src={src}
                title="Lab Rush"
                onLoad={handleLoad}
                sx={{ border: 0, width: '100%', height: '100%', display: 'block', backgroundColor: '#FAF7F3' }}
            />
        </Dialog>
    );
};

export default LabRushDialog;
